<script lang="ts">
    import { base } from '$app/paths';

    export let onLinkClick = () => {
        // noop
    };
</script>

<p class="fun-pr-6 fun-leading-relaxed fun-text-gray-700">
    By using this website you accept our <a
        class="fun-underline hover:fun-text-gray-900"
        href={`${base}/consent-policy`}
        on:click={onLinkClick}>Cookie policy</a
    >
</p>
